<template>
  <section class="aso-telefone-step">
    <h2 class="aso-telefone-step__title">Termine a validação pelo seu celular.</h2>
    <p class="aso-telefone-step__text">Você receberá um token por SMS e WhatsApp para continuar.</p>

    <input
      class="aso-telefone-step__input"
      type="text"
      inputmode="numeric"
      maxlength="15"
      :value="telefone"
      placeholder="(00) 00000-0000"
      :disabled="busy"
      @input="$emit('update:telefone', $event.target.value)"
    >

    <button
      type="button"
      class="aso-telefone-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full"
      :disabled="busy || !canContinue"
      @click="$emit('continue')"
    >
      {{ busy ? 'Enviando...' : 'Continuar' }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'AsoValidarTelefoneStep',
  props: {
    telefone: {
      type: String,
      default: '',
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canContinue() {
      return String(this.telefone || '').replace(/\D+/g, '').length >= 10
    },
  },
}
</script>



// WEBPACK FOOTER //
// AsoValidarTelefoneStep.vue?f49fb16c